import {
    DTOCardFormField,
    NestedField,
} from 'app/types/form.types'
import {
    InvoiceDesignation,
    InvoiceBulkOrIndividual,
    InvoiceStatus,
    InvoiceNormalAddon, CreditNoteReasons, LaneFeeTemplate,
} from 'app/enums/label.enums'
import {
    OutgoingInvoice,
    OutgoingInvoiceFields,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const getInvoiceFields = ({
    getAllowedValues,
    isCreditNote,
    originalInvoiceAllowedValues,
    feeTemplate,
}: {
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    isCreditNote: boolean,
    originalInvoiceAllowedValues: Record<string, any>,
    feeTemplate: LaneFeeTemplate,
}): DTOCardFormField<keyof (OutgoingInvoice & {feeTemplate: LaneFeeTemplate})>[] => {
    return [{
        title: 'Invoice',
        className: 'invoice',
        id: 'invoice',
        fields: [
            {
                id: 'column1',
                fields: [
                    {
                        name: 'invoiceDesignation',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceDesignation),
                        disabled: true,
                        labelKey: 'OutgoingInvoiceView.invoiceDesignation',
                    },
                    ...isCreditNote ? [{
                        name: 'creditNoteOriginalInvoice',
                        componentName: 'ObjectSelect',
                        allowedValues: originalInvoiceAllowedValues,
                        required: true,
                        noNone: true,
                        labelKey: 'OutgoingInvoiceView.creditNoteOriginalInvoice',
                    }] as NestedField<OutgoingInvoiceFields>[] : [],
                    ...isCreditNote ? [{
                        name: 'creditNoteReason',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(CreditNoteReasons),
                        useDropdown: true,
                        required: true,
                        noNone: true,
                        labelKey: 'OutgoingInvoiceView.creditNoteReason',
                    }] as NestedField<OutgoingInvoiceFields>[] : [],
                    {
                        name: 'invoiceDate',
                        componentName: 'DateSelect',
                        labelKey: 'OutgoingInvoiceView.invoiceDate',
                    },
                    {
                        name: 'invoiceNormalAddon',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceNormalAddon),
                        useDropdown: true,
                        labelKey: 'OutgoingInvoiceView.invoiceNormalAddon',
                    },
                ],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'invoiceBulkOrIndividual',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceBulkOrIndividual),
                        useDropdown: true,
                        labelKey: 'OutgoingInvoiceView.invoiceBulkOrIndividual',
                    },
                    {
                        name: 'invoiceTitle',
                        componentName: 'InputSingleline',
                        labelKey: 'OutgoingInvoiceView.invoiceTitle',
                    },
                    {
                        name: 'laneInfo',
                        componentName: 'InputSingleline',
                        labelKey: 'OutgoingInvoiceView.laneInfo',
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'feeTemplate',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LaneFeeTemplate),
                        value: feeTemplate,
                        disabled: true,
                        labelKey: 'AccountQuotes.feeTemplate',
                    },
                    {
                        name: 'invoiceComment',
                        componentName: 'LongText',
                        labelKey: 'OutgoingInvoiceView.invoiceComment',
                    },
                ],
            },
            {
                id: 'column4',
                fields: [
                    {
                        name: 'invoiceSentToSapOn',
                        componentName: 'DateSelect',
                        disabled: true,
                        labelKey: 'OutgoingInvoiceView.invoiceSentToSapOn',
                    },
                    {
                        name: 'changedBy',
                        componentName: 'InputSingleline',
                        disabled: true,
                        labelKey: 'OutgoingInvoiceView.changedBy',
                    },
                    {
                        name: 'invoiceStatus',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(InvoiceStatus),
                        disabled: true,
                        labelKey: 'OutgoingInvoiceView.invoiceStatus',
                    },
                ],
            },
        ],
    }]
}

export default getInvoiceFields
